import { LinkCard } from "../../types/home/links";
import LinkCardItem from "./linkCardItem";
import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";

interface ILinkCardProps {
  links: LinkCard[],
  favouriteLinks: LinkCard[],
  categorize: boolean,
  searchable?: boolean
}

const LinkCardItems = (props: ILinkCardProps) => {
  const [filteredLinks, setFilteredLinks] = useState<LinkCard[]>(props.links);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const searchFilteredLinks = searchTerm
    ? filteredLinks.filter(link =>
      link.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      link.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      link.url?.toLowerCase().includes(searchTerm.toLowerCase())
    )
    : filteredLinks;

  useEffect(() => {
    setFilteredLinks(props.links);
  }, [props.links]);

  const categorizedLinks = props.categorize ? searchFilteredLinks?.reduce((acc, link) => {
    const category = link.category || 'General';
    if (!acc[category]) acc[category] = [];
    acc[category].push(link);
    return acc;
  }, {} as { [key: string]: LinkCard[] }) : undefined;

  function setFilteredCategory(category: string): void {
    if (category === "All") {
      setFilteredLinks(props.links);
    } else {
      setFilteredLinks(props.links.filter((link) => link.category === category));
    }
  }

  return (
    <>
      {props.searchable && (
        <div className="mb-5">
          <Input
            placeholder="Search links..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      )}

      <div style={{ maxHeight: 'calc(100vh - 13rem)', overflowY: 'auto' }}>
        {props.categorize && categorizedLinks && (
          <div className="flex flex-wrap mb-5">
            <button key="All" className="category-button" onClick={() => setFilteredCategory("All")}>All</button>
            {Object.keys(categorizedLinks)
              .sort((a, b) => a.localeCompare(b))
              .map((category) => (
                <button key={category} className="category-button" onClick={() => setFilteredCategory(category)}>
                  {category}
                </button>
              ))}
          </div>
        )}

        {!props.categorize && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {searchFilteredLinks?.map((link: LinkCard, index) => {
              const favorite = props.favouriteLinks?.some((favLink) => favLink.title === link.title);
              return (
                <div key={index} className="min-w-0 w-full">
                  <LinkCardItem link={link} favorite={favorite} />
                </div>
              );
            })}
          </div>
        )}

        {props.categorize && categorizedLinks && Object.keys(categorizedLinks)
          .sort((a, b) => a.localeCompare(b))
          .map((category) => (
            <div key={category}>
              <h3 className="font-medium text-primary ml-2.5">{category}</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {categorizedLinks[category].map((link: LinkCard, index) => {
                  const favorite = props.favouriteLinks?.some((favLink) => favLink.title === link.title);
                  return (
                    <div key={index} className="min-w-0 w-full">
                      <LinkCardItem link={link} favorite={favorite} />
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
      </div>
    </>
  );
}

export default LinkCardItems;
